import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { environment } from 'src/environments/environment';
import { CommonService } from "../library/pcl_lib";
import { Globals } from "../global/global-variable";
import axios from "axios";
@Injectable({
    providedIn : "root"
})

export class ManifestService {
    constructor(private router: Router,
        private http: HttpClient,
        private global : Globals,
        private lib : CommonService){        
    }//end constructor

    public filterList(q): Observable<result_data>{
        const headers = new HttpHeaders({
            'Authorization' : 'Bearer '+localStorage.getItem('accessToken')
        });
        const requestOptions: Object = {
            responseType: 'json',
            headers : headers
        }//end
        return this.http.post(environment.get_data_staging,q,requestOptions);
    }//end

    public sendManifest(q): Observable<result_data>{
        const headers = new HttpHeaders({
            'Authorization' : 'Bearer '+localStorage.getItem('accessToken')
        });
        const requestOptions: Object = {
            responseType: 'json',
            headers : headers
        }//end
        return this.http.post(environment.send_manifest_staging,q,requestOptions);
    }//end

    public generate_manifest(q): Observable<result_data>{
        const headers = new HttpHeaders({
            'Authorization' : 'Bearer '+localStorage.getItem('accessToken')
        });

        const requestOptions: Object = {
            responseType: 'json',
            headers : headers
        }//end
        
        return this.http.post(environment.generate_pdf,q,requestOptions);
    }

    public generate_manifest_wikidata(q): Observable<result_data>{
        const headers = new HttpHeaders({
            'Authorization' : 'ApiKey '+environment.web_api_key
        });

        const requestOptions: Object = {
            responseType: 'json',
            headers : headers
        }//end
        
        return this.http.post(environment.generate_pdf_wikidata,q,requestOptions);
    }

    public generate_manifest_wikidata_single(q): Observable<result_data>{
        const headers = new HttpHeaders({
            'Authorization' : 'ApiKey '+environment.web_api_key
        });

        const requestOptions: Object = {
            responseType: 'json',
            headers : headers
        }//end
        
        return this.http.post(environment.generate_pdf_wikidata_single,q,requestOptions);
    }

    public generate_manifest_adverse(q): Observable<result_data>{
        const headers = new HttpHeaders({
            'Authorization' : 'ApiKey '+environment.google_custom_search_key
        });

        const requestOptions: Object = {
            responseType: 'json',
            headers : headers
        }//end
        
        return this.http.post(environment.generate_pdf_adverse,q,requestOptions);
    };

    public generate_manifest_adverse_single(q): Observable<result_data>{
        const headers = new HttpHeaders({
            'Authorization' : 'ApiKey '+environment.google_custom_search_key
        });

        const requestOptions: Object = {
            responseType: 'json',
            headers : headers
        }//end
        
        return this.http.post(environment.generate_pdf_adverse_single,q,requestOptions);
    }

    public generate_manifest_single(q): Observable<result_data>{
        const headers = new HttpHeaders({
            'Authorization' : 'ApiKey '+environment.web_api_key
        });

        const requestOptions: Object = {
            responseType: 'json',
            headers : headers
        }//end
        
        return this.http.post(environment.generate_pdf_single,q,requestOptions);
    }
}//end class

export interface result_data {}